// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, 
    Route } from 'react-router-dom';
import './App.css';
import { CookieProvider, CookieBanner } from './CookieContext';
import BackgroundCanvas from './BackgroundCanvas';
import { AuthProvider, } from './auth';
import AppContent from './AppContent';


function App() {
  return (
    <CookieProvider>
      <CookieBanner />
      <AuthProvider>
        <Router>
          {/* <BackgroundCanvas /> */}
          <Routes>
            <Route path="/*" element={<AppContent />} />
          </Routes>
        </Router>
      </AuthProvider>
    </CookieProvider>
  );
}

export default App;
